import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../common/Loader";
import { updateChequeDetailsAction } from "../../redux/actions/studentActions";
import AgGridTable from "../Tables/agGridTable";
import BreadCrumb from "../BreadCrumb";
import {
  getPendingPayments,
  resetPaymentsData,
} from "../../redux/actions/pendingPaymentsActions";
import { Link } from "react-router-dom";
import UpdateChequeDetails from "../PaymentsLIst/updateChequeDetails";
import PaymentDetails from "../PaymentsLIst/PaymentDetails";
import { ERROR, ToastMessage } from "../../common/ToastMessage";

const PendingPayments = (props) => {
  const dispatch = useDispatch();
  const { pendingPaymentsData, loader, pagination } = useSelector(
    (state) => state.pendingPayments
  );
  const [sideMenu, setSideMenu] = useState(true);
  const [show, setShow] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [agGridRef, setAgGridRef] = useState(null);
  const [chequeStatusUpdated, setChequeStatusUpdated] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState({});
  const [chequeShow, setChequeShow] = useState(false);

  const onSideMenu = (value) => {
    setSideMenu(value);
  };

  useEffect(() => {
    dispatch(resetPaymentsData());
    dispatch(
      getPendingPayments({
        page: 1,
        perPage: pagination.perPage,
        setChequeStatusUpdated,
      })
    );
    setChequeStatusUpdated(false);
  }, [dispatch, pagination.perPage, chequeStatusUpdated]);

  const updateChequeDetails = async (data, rowNodeRef) => {
    setSelectedTransaction(data);
    setChequeShow(true);
  };

  const actionsListComponent = (props) => {
    return (
      <>
        <i
          class={"fa  fa-check-circle"}
          aria-hidden="true"
          title="Update Cheque Detail"
          style={{
            alignItems: "center",
            color: "#1c5983",
            cursor: "pointer",
            fontSize: "18px",
          }}
          onClick={() => {
            props.updateChequeDetails(props.data, {});
          }}
        ></i>
      </>
    );
  };

  const columnDefs = [
    {
      headerName: "Registration Number",
      field: "regNo",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Student Name",
      field: "name",
      sortable: true,
      filter: true,
      floatingFilter: true,
      cellRendererFramework: (params) => {
        return (
          <Link to={`/studentsList/details/${params.data?.StudentId}`}>
            {params.value}
          </Link>
        );
      },
      cellClass: "vertical-middle",
    },
    {
      headerName: "Branch",
      field: "branch",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Order Id",
      field: "orderId",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Amount",
      field: "amount",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Payment Mode",
      field: "paymentMode",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Cheque/Transaction Number",
      field: "transactionNumber",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Issue Date",
      field: "chequeIssueDate",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Expiry Date",
      field: "chequeExpiryDate",
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    {
      headerName: "Name Of Bank",
      field: "nameOfBank",
    },
    {
      headerName: "Account Holder Name",
      field: "accountHolderName",
    },
    {
      headerName: "Account Number",
      field: "accountNumber",
    },
    {
      headerName: "Paid On",
      field: "paidOn",
    },

    {
      headerName: "Action",
      field: "action",
      maxWidth: 100,
      cellRenderer: "actionsListComponent",
      cellRendererParams: {
        updateChequeDetails,
      },
    },
  ];

  const fetchParamsList = async () => {
    const params = {
      name,
      email,
      phone,
      perPage: pagination.perPage,
    };
    return params;
  };

  const closeModal = () => {
    setShow(false);
    setChequeShow(false);
  };

  const fetchMoreData = async () => {
    console.log(pagination, pendingPaymentsData.pendingPayments);
    if (
      pagination.totalPages === 1 ||
      pagination.totalPages - 1 === pagination.currentPage
    ) {
      setHasMore(false);
      return;
    }
    let reqParams = await fetchParamsList();
    reqParams.page = pagination.currentPage + 1;
  };
  const setGridRefData = (params) => {
    setAgGridRef(params);
  };

  const updateChequeInfo = async (data) => {
    const chequeIssueDateInDateObjectFormat = new Date(
      selectedTransaction?.chequeIssueDate
    );
    const chequeResolvedDateInDateObjectFormat = new Date(data?.clearedDate);
    const chequeExpiryDateInDateObjectFormat = new Date(
      selectedTransaction?.chequeExpiryDate
    );
    const currentDate = new Date();

    if (selectedTransaction?.paymentMode === "Cheque") {
      if (
        chequeResolvedDateInDateObjectFormat < chequeIssueDateInDateObjectFormat
      ) {
        ToastMessage(
          ERROR,
          "Cheque Resolved Date should be greater than or equal to Cheque Issue Date"
        );
      } else if (
        chequeResolvedDateInDateObjectFormat >
        chequeExpiryDateInDateObjectFormat
      ) {
        ToastMessage(
          ERROR,
          "Cheque Resolved Date should be lesser than or equal to Cheque Expiry Date"
        );
      } else if (chequeResolvedDateInDateObjectFormat > currentDate) {
        ToastMessage(
          ERROR,
          "Cheque Resolved Date should be lesser than or equal to today's date"
        );
      } else {
        const reqParams = {
          ...data,
          PaymentId: selectedTransaction?.id,
          ChequeTransactionId: selectedTransaction?.ChequeTransaction?.id,
        };
        await dispatch(
          updateChequeDetailsAction(
            reqParams,
            pendingPaymentsData?.pendingPayments
          )
        );
        setChequeShow(false);
        setChequeStatusUpdated(true);
      }
    } else {
      // non cheque payments

      const reqParams = {
        ...data,
        PaymentId: selectedTransaction?.id,
        ChequeTransactionId: selectedTransaction?.ChequeTransaction?.id,
      };
      await dispatch(
        updateChequeDetailsAction(
          reqParams,
          pendingPaymentsData?.pendingPayments
        )
      );
      //  let updateObj = { ...rowNode.data}
      //   if(reqParams.chequeStatus === APPORVED){
      //     updateObj.paymentStatus = "Payment Completed"
      //   }else{
      //     updateObj.paymentStatus = "Payment Failed"
      //   }
      //  rowNode.setData({...updateObj});
      setChequeShow(false);
      setChequeStatusUpdated(true);
    }
  };

  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader}>
        {show && (
          <PaymentDetails
            show={show}
            data={selectedTransaction.paymentInfo}
            closeModal={closeModal}
          />
        )}
        {chequeShow && (
          <UpdateChequeDetails
            show={chequeShow}
            data={selectedTransaction.paymentInfo}
            closeModal={closeModal}
            update={updateChequeInfo}
          />
        )}

        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <div className="spacer"> </div>
          <>
            <AgGridTable
              key={"pendingPpendingPaymentsayments"}
              rowData={pendingPaymentsData.pendingPayments}
              columnDefs={columnDefs}
              defaultColDef={{ resizable: true, minWidth: 100 }}
              frameworkComponents={{
                actionsListComponent,
              }}
              pagination={pagination}
              // isPaginationRequired={true}
              // fetchParamsList={fetchParamsList}
              // actionType={SET_REGISTRATION_PENDING_STUDENTS}
              // setAgGridRef={setGridRefData}
            />
          </>
        </div>
      </PageLoader>
    </div>
  );
};

export default PendingPayments;
